import { Cell, Column, Content, Flex, Grid, Heading, IllustratedMessage, Item, Link, ListBox, ProgressCircle, Row, TableBody, TableHeader, TableView, ToastQueue, useAsyncList, View } from '@adobe/react-spectrum';
import { useInvoiceAppType } from './Invoice.hooks';
import { useDependency } from '../../../contexts/DependencyProvider';
import { ListInvoiceRequest } from '../../../services/soap/invoice/requests/ListInvoiceRequest';
import useBrowserName from '../../../hooks/UseBrowserName';
import useScreenSize from '../../../hooks/UseScreenSize';
import { useTranslation } from 'react-i18next';
import { useViewInfo } from '../../../hooks/UseViewInfo';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LayoutDefinition } from '../../../infra/protected/Layout/LayoutDefinitions';
import { useDeviceDetection } from '../../../hooks/UseDeviceDetection';
import { updateAppInfo } from '../../../state/userWebLayout/userWebLayoutSlice';
import { addKey, useKeyboardShortcuts } from '../../../hooks/UseKeyboardShortcuts';
import NotFound from '@spectrum-icons/illustrations/NotFound';
import { DeleteConfirmationDialog } from '../finder/components/DeleteConfirmationDialog';
import styles from './Invoice.module.css';
import FilterComponent from './components/FilterComponent';
import CardComponent from './components/CardComponent';
import FilterSearchTextBox from './components/FilterSearchTextBox';
import HeaderComponent from './components/HeaderComponent';
import { ListInvoiceStatusRequest } from '../../../services/soap/invoice/requests/ListInvoiceStatusRequest';
import { statusColor } from '../../../utils/helperUtil';
import { SumInvoiceRequest } from '../../../services/soap/invoice/requests/SumInvoiceRequest';
import InvoiceDetailView from './components/InvoiceDetailView';
import { GetInvoiceRequest } from '../../../services/soap/invoice/requests/GetInvoiceRequest';
import AddUpdateInvoice from './components/AddUpdateInvoice';
import InvoiceListTable from './InvoiceListTable';
import { CircleFill } from 'react-bootstrap-icons';
import { invokeInvoiceApp } from '../../../utils/NavigationUtils';
import { UpdateInvoiceRequest } from '../../../services/soap/invoice/requests/UpdateInvoiceRequest';
import { DeleteInvoiceRequest } from '../../../services/soap/invoice/requests/DeleteInvoiceRequest';
export interface IInvoiceProps {

}

interface Character {
  id: string;
  name: string;
}

export function Invoice(props: IInvoiceProps) {
  const { invoiceType, apiParams } = useInvoiceAppType();
  const { store, invoiceService } = useDependency();
  const browserName = useBrowserName();
  const screenSize = useScreenSize();
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_detail.${key}`, { ns: 'invoice' });
  const _tt = (key: string) => t(`invoice_common.${key}`, { ns: 'invoice' });
  const _ttt = (key: string) => t(`invoice_table_column.${key}`, { ns: 'invoice' });

  const { isMobile } = useViewInfo();
  const dataStore = useSelector((state: any) => state.userWebLayout.appInfos);
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const selectedAppInfo = useSelector((state: RootState) => state.userWebLayout.selectedApp);
  const dispatch = useDispatch();
  const location = useLocation();
  const appKey = (location.state as { appKey?: string } | null)?.appKey;
  const [showLoader, setShowLoader] = useState(true);
  const [showLoaderDetail, setShowLoaderDetail] = useState(true);
  const [rowsData, setRowsData] = useState<any>([]);
  const [columnsData, setColumnsData] = useState<any>([]);
  const [pageView, setPageView] = useState<string>('Full');
  const [selectedKeys, setSelectedKeys] = useState<Set<any>>();
  const [invoiceStatusList, setInvoiceStatusList] = useState<any>([]);
  const [definition, setDefinition] = useState<LayoutDefinition | null>(null);
  const [showMobileDetailView, setShowMobileDetailView] = useState<boolean>(false);
  const [stopLoadData, setStopLoadData] = useState<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>('');
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [selectedDataRow, setSelectedDataRow] = useState<any>({});
  const serviceActivityValue = useRef<string>('');
  const queryParams = useRef<any>({ FILTER: { COL: [] } });
  const restoredSelectedIdRef = useRef<string>('');
  const totalProductListRec = useRef<number>(0);
  const offSetLimit = useRef<number>(0);
  const dataRef = useRef<any>({});
  const [showAdd, setShowAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [params] = useSearchParams();
  const [showCards, setShowCards] = useState<boolean>(true);
  const [isOpen, setOpen] = useState(false);
  const deviceInfo = useDeviceDetection(isMobile);
  const [showFilter, setshowFilter] = useState<boolean>(false);
  const [sumInvoice, setSumInvoice] = useState<any>()
  const [forceAddMode, setForceAddMode] = useState(false);
  const PAGE_SIZE = 50;
  const getInvoicePrintType = useCallback((invoice: any) => {
    const baseType = String(invoice?.baseType || '').trim();
    const isIssued = String(invoice?.isIssued || '').trim();

    if (baseType === '1' && isIssued === '1') return 'invoice';
    if (baseType === '1' && isIssued === '0') return 'invoice_received';
    if (baseType === '2' && isIssued === '0') return 'sales_order';
    if (baseType === '2' && isIssued === '1') return 'purchase_order';
    if (baseType === '4' && isIssued === '0') return 'estimate';
    if (baseType === '8' && isIssued === '0') return 'offer_received';

    return 'invoice';
  }, []);
  const addContextParams = useMemo(() => {
    if (params.get('mode') !== 'add') return {};
    const folder = params.get('folder');
    const project = params.get('project');
    const activity = params.get('activity');
    return {
      ...(folder ? { folder } : {}),
      ...(project ? { project } : {}),
      ...(activity ? { activity } : {}),
    };
  }, [params]);
  const selectedInvoiceApiParams = useMemo(
    () => ({ ...apiParams, ...addContextParams }),
    [apiParams, addContextParams]
  );

  useEffect(() => {
    (async () => {
      const hasDirectNavigation = params.has('id') || params.get('mode') === 'add';
      const cachedState = appKey ? dataStore?.[appKey] : undefined;
      const hasRestoredContext = !hasDirectNavigation && !!cachedState;

      if (!hasDirectNavigation && cachedState) {
        try {
          const cachedPageView = cachedState?.pageView || 'Full';
          const cachedQueryParams = cachedState?.queryParams
            ? JSON.parse(cachedState.queryParams)
            : { FILTER: { COL: [] } };
          const cachedSelectedId = String(cachedState?.selectedInvoiceId || '').trim();

          queryParams.current = cachedQueryParams;
          setPageView(cachedPageView);
          dataRef.current.pageView = cachedPageView;
          setShowCards(cachedState?.showCards !== undefined ? !!cachedState.showCards : true);
          setIsEdit(!!cachedState?.isEdit);
          setForceAddMode(!!cachedState?.forceAddMode);
          setShowMobileDetailView(!!cachedState?.showMobileDetailView);
          setSearchedValue(String(cachedState?.searchedValue || ''));

          if (cachedSelectedId) {
            restoredSelectedIdRef.current = cachedSelectedId;
            setSelectedKeys(new Set([cachedSelectedId]));
          }
        } catch {
          queryParams.current = { FILTER: { COL: [] } };
          restoredSelectedIdRef.current = '';
          setPageView('Full');
          dataRef.current.pageView = 'Full';
          setSearchedValue('');
          setShowCards(true);
          setIsEdit(false);
          setForceAddMode(false);
          setShowMobileDetailView(false);
        }
      } else {
        queryParams.current = { FILTER: { COL: [] } };
        restoredSelectedIdRef.current = '';
        setPageView('Full');
        dataRef.current.pageView = 'Full';
        setSearchedValue('');
        setShowCards(true);
        setIsEdit(false);
        setForceAddMode(false);
        setShowMobileDetailView(false);
      }

      if (params.has('id')) {
        setShowCards(false);
        setIsEdit(false);
        setForceAddMode(false);
      } else if (params.get('mode') === 'add') {
        setShowCards(false);
        setIsEdit(false);
        setForceAddMode(true);
      } else if (!hasRestoredContext) {
        // Only reset to default view when we are not restoring persisted state.
        setIsEdit(false);
        setForceAddMode(false);
      }
      setShowLoader(true);
      setShowLoaderDetail(true);
      serviceActivityValue.current = '';
      Promise.all([getInvoiceStatusList(), getSumInvoice()]);
    })();
  }, [invoiceType, appKey, dataStore, params]);

  useEffect(() => {
    if (selectedApp !== '') {
      invoiceList.reload();
    }
  }, [selectedApp, invoiceType, appKey]);

  useEffect(() => {
    return () => {
      if (!appKey) {
        return;
      }
      dispatch(
        updateAppInfo({
          key: appKey,
          data: {
            pageView: dataRef.current.pageView,
            queryParams: JSON.stringify(dataRef.current.queryParams || { FILTER: { COL: [] } }),
            selectedInvoiceId: dataRef.current.selectedInvoiceId || '',
            selectedKeys:
              dataRef.current.selectedKeys && dataRef.current.selectedKeys.size > 0
                ? JSON.stringify(Array.from(dataRef.current.selectedKeys))
                : undefined,
            showCards: !!dataRef.current.showCards,
            isEdit: !!dataRef.current.isEdit,
            forceAddMode: !!dataRef.current.forceAddMode,
            showMobileDetailView: !!dataRef.current.showMobileDetailView,
            searchedValue: dataRef.current.searchedValue || '',
          },
        })
      );
    };

  }, [appKey, dispatch]);

  useEffect(() => {
    dataRef.current.pageView = pageView;
    dataRef.current.queryParams = queryParams.current;
    dataRef.current.selectedInvoiceId = String(selectedItem?.id || selectedDataRow?.id || '').trim();
    dataRef.current.selectedKeys = selectedKeys;
    dataRef.current.showCards = showCards;
    dataRef.current.isEdit = isEdit;
    dataRef.current.forceAddMode = forceAddMode;
    dataRef.current.showMobileDetailView = showMobileDetailView;
    dataRef.current.searchedValue = searchedValue;
  }, [pageView, selectedItem, selectedDataRow, selectedKeys, showCards, isEdit, forceAddMode, showMobileDetailView, searchedValue]);

  const getStableColorSeedFromState = (state: any) => {
    const key = String(state ?? '');
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }
    return (hash % 16777215) + 1;
  };

  const getStateColor = (state: any) => {
    const colorSeed = getStableColorSeedFromState(state);
    return statusColor(colorSeed.toString());
  };

  const getInvoiceStatusList = useCallback(async () => {
    if (invoiceStatusList?.length > 0) {
      return invoiceStatusList;
    }

    const statusArray: any = [];
    let res: any = await invoiceService.listInvoiceStatus(new ListInvoiceStatusRequest(store.Server, store.SessionId, { limit: 50, offset: 0 }));
    if (res.result === 'OK' && res.ITEM.length > 0) {
      res?.ITEM.forEach((status: any) => {
        const { id, name } = status;
        const colorString = getStateColor(id);
        statusArray.push({ ...status, id, name, color: colorString });
      });

      setInvoiceStatusList(statusArray);
      return statusArray;
    }
  }, [invoiceService, store.Server, store.SessionId, invoiceStatusList]);

  const mapFiltersToRequest = (filters: { COL: any[] }) => {
    const requestParams: {
      orderBy?: string;
      countOnly?: boolean;
      type?: string;
      status?: string;
      state?: string;
      paymentStatus?: string;
      refId?: string;
      manufacturer?: string;
      invoiceNumber?: string;
      forApproval?: string;
      overdue?: string;
    } = {
      orderBy: 'name',
    };

    filters.COL.forEach(filter => {
      if (filter.name === 'invoiceNumber') {
        requestParams.invoiceNumber = `${filter.value}`;
      }
      if (filter.name === 'status') {
        requestParams.status = filter.value;
      }
      if (filter.name === 'state') {
        requestParams.state = filter.value;
      }
      if (filter.name === 'paymentStatus') {
        requestParams.paymentStatus = filter.value;
      }
      if (filter.name === 'view') {
        if (filter.value === 'invoice_my_approval') {
          requestParams.forApproval = '1';
        }
        if (filter.value === 'invoice_overdue') {
          requestParams.overdue = '1';
        }
      }
    });
    return requestParams;
  };

  const getSumInvoice = useCallback(async () => {
    const requestParams = mapFiltersToRequest(queryParams.current.FILTER);
    const response: any = await invoiceService.sumInvoice(new SumInvoiceRequest(store.Server, store.SessionId, {
      orderBy: 'created',
      orderBytype: 1,
      FILTER: { ...apiParams, ...requestParams }
    }))

    if (response.result === "OK") {
      setSumInvoice(response.INVOICE)
    }
  }, [apiParams, invoiceService, store.Server, store.SessionId]);

  const getInvoiceCount = async () => {

    const requestParams = mapFiltersToRequest(queryParams.current.FILTER);

    const response = await invoiceService.listInvoices(new ListInvoiceRequest(store.Server, store.SessionId, {
      FILTER: { ...apiParams, ...requestParams },
      countOnly: true,
    }));

    totalProductListRec.current = response.count || 0;

    return response.count || 0;
  }

  const getInvoiceStatusColor = (statusArray: any[], invoiceStatus: any) => {
    const statusObj = statusArray.find((obj: any) => obj.id == invoiceStatus);
    return (
      <>
        <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={getStateColor(invoiceStatus)} /> {statusObj?.name}
      </>
    );
  };

  const loadInvoiceList = async () => {
    try {
      if (stopLoadData) {
        return rowsData;
      }

      const statusArray = await getInvoiceStatusList();

      const requestParams = mapFiltersToRequest(queryParams.current.FILTER);
      setSearchedValue('');
      const response = await invoiceService.listInvoices(new ListInvoiceRequest(store.Server, store.SessionId, {
        FILTER: { ...apiParams, ...requestParams },
        limit: PAGE_SIZE,
        offset: offSetLimit.current,
      }));

      let itemList: any[] = [];
      if (response.result === 'OK' && response?.count > 0) {
        if (Array.isArray(response.INVOICE)) {
          itemList = response.INVOICE;
        } else if (response.INVOICE) {
          itemList = [response.INVOICE];
        }

        itemList = itemList.map((item: any) => {
          return {
            ...item,
            status: getInvoiceStatusColor(statusArray, item.state),
            statusColor: getStatusColor(statusArray, item.state),
          };
        });

        if (offSetLimit.current === 0) {
          setRowsData(itemList);
          const firstId = String(itemList[0]?.id || '');
          const restoreId = String(restoredSelectedIdRef.current || '').trim();
          const restoredExists = restoreId && itemList.some((row: any) => String(row?.id) === restoreId);
          const defaultId = restoredExists ? restoreId : firstId;
          if (defaultId) {
            setSelectedKeys(new Set([defaultId]));
          }

          if (params.has('id')) {
            const requestedId = String(params.get('id') ?? '');
            const existsInList = itemList.some((row: any) => String(row?.id) === requestedId);
            if (requestedId && existsInList) {
              getLayout(requestedId);
            } else if (itemList[0]?.id) {
              // URL id may point to deleted/non-visible invoice; fallback to first available row.
              getLayout(String(itemList[0].id));
            }
          } else if (restoreId && restoredExists) {
            getLayout(restoreId);
          } else if (!selectedItem) {
            getLayout(itemList[0]?.id);
          }
        } else {
          setRowsData((prev: any) => [...prev, ...itemList]);
        }

        return itemList;
      } else {
        ToastQueue.info(t('no_results', { ns: 'layout_components' }), { timeout: 50 });
        setRowsData([]);
        return [];
      }
    } finally {
      setShowLoader(false);
    }
  };

  const getLayout = async (selectedId: any) => {
    try {
      const invoiceResult = await invoiceService.getInvoice(new GetInvoiceRequest(store.Server, store.SessionId, { id: selectedId }));
      if (invoiceResult.result === 'OK') {
        const statusArray = invoiceStatusList?.length > 0 ? invoiceStatusList : await getInvoiceStatusList();
        const invoice = invoiceResult.INVOICE;
        let result = null;
        if (Array.isArray(invoice)) {
          result = invoice.length > 0 ? extractSingleObject(invoice[0]) : null;
        } else {
          result = invoice;
        }

        if (!result) {
          return null;
        }

        const mappedResult = {
          ...result,
          status: getInvoiceStatusColor(statusArray || [], result.state),
          statusColor: getStatusColor(statusArray || [], result.state),
        };
        console.log('getLayout mappedResult: ', mappedResult);
        setSelectedDataRow(mappedResult);
        setSelectedItem(mappedResult);
        setSelectedKeys(new Set([String(mappedResult.id)]));
        setShowLoaderDetail(false);
        return mappedResult;
      }
    } catch (err) {
      console.error('getlayout error: ', err);
    } finally {
      setShowLoaderDetail(false);
    }
  };

  const invoiceList = useAsyncList<Character>({
    async load({ cursor, signal }) {
      try {
        if (!selectedApp) {
          return { items: [], cursor: undefined };
        }

        const currentPage = cursor ? parseInt(cursor, 10) : 0;
        const estimatedLoadedCount = currentPage * PAGE_SIZE;
        if (cursor && estimatedLoadedCount >= totalProductListRec.current) {
          return { items: [], cursor: undefined };
        }
        const totalRecords = currentPage === 0 ? await getInvoiceCount() : totalProductListRec.current;

        if (signal?.aborted) {
        }
        const offset = Math.min(PAGE_SIZE * currentPage, totalRecords ?? 0);

        offSetLimit.current = offset;

        const items: any = await loadInvoiceList();
        const hasMoreItems = offset + (items?.length || 0) < (totalRecords ?? 0);
        const nextCursor = hasMoreItems ? String(currentPage + 1) : undefined;
        await getSumInvoice();
        return {
          items: items || [],
          cursor: nextCursor,
        };
      } catch (error) {
        console.error('Error loading activity list:', error);
        ToastQueue.negative(t('error_loading_data', { ns: 'layout_components' }) || 'Error loading data', { timeout: 3000 });
        return { items: [], cursor: undefined };
      } finally {
        setShowLoader(false);
        setshowFilter(true);
      }
    },
    async sort({ items, sortDescriptor }) {
      if (!sortDescriptor) return { items };
      const { column, direction } = sortDescriptor;
      return {
        items: [...items].sort((a: any, b: any) => {
          const aValue = a[column];
          const bValue = b[column];

          let result = 0;
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            result = aValue.localeCompare(bValue);
          } else if (aValue < bValue) {
            result = -1;
          } else if (aValue > bValue) {
            result = 1;
          }

          return direction === 'descending' ? -result : result;
        }),
      };
    },

    getKey: item => item.id,
  });

  const reloadInvoices = useCallback((filterParams: any) => {
    setStopLoadData(false);
    queryParams.current = filterParams;
    totalProductListRec.current = 0;
    offSetLimit.current = 0;
    setRowsData([]);
    setSelectedItem(null);
    setSelectedDataRow({});
    setSelectedKeys(undefined);
    setShowCards(true);
    invoiceList.reload();
  }, []);

  const getSelectedKey = (selection: any): string | null => {
    if (selection === null || selection === undefined || selection === 'all') {
      return null;
    }
    if (typeof selection === 'string' || typeof selection === 'number') {
      return String(selection);
    }
    if (selection instanceof Set) {
      const first = selection.values().next().value;
      return first !== undefined ? String(first) : null;
    }
    if (typeof selection === 'object' && selection.currentKey !== undefined && selection.currentKey !== null) {
      return String(selection.currentKey);
    }
    return null;
  };

  const handleTableRowClick = (rowId: any): void => {
    const rowKey = getSelectedKey(rowId);
    if (!rowKey) {
      return;
    }

    // In table/list view we must allow opening detail even for already-selected row.
    if (selectedKeys?.has(rowKey) && pageView === 'Full') {
      return;
    }

    setShowLoaderDetail(true);
    setSelectedKeys(new Set([rowKey]));
    setPageView('Full');
    dataRef.current.pageView = 'Full';
    const selectedRow = rowsData.find((item: any) => String(item.id) === rowKey);
    if (!selectedRow) {
      setSelectedDataRow({});
      setSelectedKeys(undefined);
      setDefinition(null);
      return;
    }
    setSelectedDataRow(selectedRow);
    getLayout(rowKey);
  };

  const handleListRowClick = (rowId: any): void => {
    const rowKey = getSelectedKey(rowId);
    if (!rowKey || selectedKeys?.has(rowKey)) {
      return;
    } else {
      setShowLoaderDetail(true);
      setSelectedKeys(new Set([rowKey]));
      setPageView('Full');
      dataRef.current.pageView = 'Full';
      const selectedRow = rowsData.find((item: any) => String(item.id) === rowKey);
      if (!selectedRow) {
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setDefinition(null);
        return;
      }
      setSelectedDataRow(selectedRow);
      getLayout(rowKey);
    }
  };

  const handleRowClickMobile = (rowId: any): void => {
    const rowKey = getSelectedKey(rowId);
    if (!rowKey) {
      return;
    }
    const nameSearchExists = queryParams.current.FILTER.COL.find((col: any) => col.name === 'nameSearch');
    if (nameSearchExists) {
      setSearchedValue(nameSearchExists.value);
    }
    setSelectedKeys(undefined);
    const selectedRow = rowsData.find((item: any) => String(item.id) === rowKey);
    if (!selectedRow) {
      setSelectedDataRow({});
      setSelectedKeys(undefined);
      setDefinition(null);
      return;
    }
    setSelectedDataRow(selectedRow);
    getLayout(rowKey);
    setShowMobileDetailView(true);
  };

  const handleOpenInvoiceApp = (item: any) => {
    const invoiceId = item?.id;
    if (!invoiceId) return;
    invokeInvoiceApp(String(invoiceId), selectedAppInfo?.appIdent);
  };

  const handleViewChange = (view: string) => {
    setPageView(view);
    setShowCards(true);
    dataRef.current.pageView = view;
  };

  const handleBackToList = () => {
    setStopLoadData(true);
    setShowMobileDetailView(false);
    setShowCards(true);
  };

  const handleInvoiceStatusChange = async (statusId: string) => {
    if (!selectedItem?.id || !statusId || String(selectedItem?.state) === String(statusId)) {
      return;
    }

    const statusObj = (invoiceStatusList || []).find((s: any) => String(s?.id) === String(statusId));
    const nextInvoice = {
      ...selectedItem,
      state: String(statusId),
      stateName: statusObj?.name || selectedItem?.stateName || '',
    };

    try {
      setShowLoaderDetail(true);
      const res: any = await invoiceService.updateInvoice(
        new UpdateInvoiceRequest(store.Server, store.SessionId, nextInvoice)
      );

      if (res?.result !== 'OK') {
        ToastQueue.negative(
          res?.EXCEPTION?.message ||
            res?.EXCEPTION?.reason ||
            t('failed_to_update_status', {
              ns: 'layout_components',
              defaultValue: 'Failed to update status.',
            }),
          { timeout: 3000 },
        );
        setShowLoaderDetail(false);
        return;
      }

      await getLayout(String(selectedItem.id));

      setRowsData((prev: any) =>
        Array.isArray(prev)
          ? prev.map((row: any) =>
            String(row?.id) === String(selectedItem.id)
              ? {
                ...row,
                state: String(statusId),
                stateName: statusObj?.name || row?.stateName,
                status: getInvoiceStatusColor(invoiceStatusList || [], String(statusId)),
                statusColor: getStatusColor(invoiceStatusList || [], String(statusId)),
              }
              : row
          )
          : prev
      );

      ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    } catch (error: any) {
      ToastQueue.negative(
        error?.message ||
          t('failed_to_update_status', {
            ns: 'layout_components',
            defaultValue: 'Failed to update status.',
          }),
        { timeout: 3000 },
      );
    } finally {
      setShowLoaderDetail(false);
    }
  };

  const getStatusColor = (statusArray: any, status: any) => {
    return getStateColor(status);
  };

  function extractSingleObject(data: any): any {
    if (typeof data !== 'object' || data === null) {
      return null;
    }
    const keys = Object.keys(data);
    if (keys.some(key => !isNaN(Number(key)))) {
      for (const key of keys) {
        if (!isNaN(Number(key))) {
          return data[key];
        }
      }
    }
    return data;
  }

  const Loader = () => (
    <Flex width="100%" justifyContent="center" marginTop={10}>
      <ProgressCircle aria-label={t('loading', { ns: 'layout_components', defaultValue: 'Loading...' })} isIndeterminate />
    </Flex>
  );

  const NoResultsMessage = () => (
    <Flex direction="row" width="100%" alignContent="center" justifyContent="center">
      <IllustratedMessage>
        <NotFound />
        <Heading>{t('no_results', { ns: 'layout_components' })}</Heading>
        <Content>{t('try_another_search', { ns: 'layout_components' })}</Content>
      </IllustratedMessage>
    </Flex>
  );

  const getHeight = (baseHeight: number) => {
    if (browserName === 'Chrome') {
      return `${baseHeight - 120}px`;
    } else if (browserName === 'Safari') {
      return `${baseHeight - 120}px`;
    } else {
      return `${baseHeight - 120}px`;
    }
  };

  const getWidth = () => {
    return `95%`;
  };

  const detailStyle = {
    height: getHeight(screenSize.height - 20),
  };

  const cardStyle = {
    height: getHeight(screenSize.height),
    width: getWidth(),
    top: 0,
  };

  const filterStyle = {
    height: getHeight(screenSize.height + 60),
    overflow: 'hidden auto',
  };

  const handleAddNew = () => {
    setForceAddMode(true);
    setIsEdit(false);
    setShowCards(false);
  };

  const handleEditClick = (data: boolean) => {
    if (data) {
      setForceAddMode(false);
      setIsEdit(data);
      setShowCards(false);
    }
  };

  const handleInvoiceSaveSuccess = async (invoiceId?: any) => {
    const id = invoiceId || selectedItem?.id;
    const normalizedId = id !== undefined && id !== null ? String(id) : '';

    setIsEdit(false);
    setForceAddMode(false);

    if (!normalizedId) {
      invoiceList.reload();
      return;
    }

    setShowLoaderDetail(true);
    const refreshed = await getLayout(normalizedId);

    if (refreshed) {
      setRowsData((prev: any) =>
        Array.isArray(prev)
          ? (() => {
            const exists = prev.some((row: any) => String(row?.id) === normalizedId);
            if (exists) {
              return prev.map((row: any) =>
                String(row?.id) === normalizedId ? { ...row, ...refreshed } : row
              );
            }
            return [refreshed, ...prev];
          })()
          : [refreshed]
      );
      setSelectedKeys(new Set([normalizedId]));
    }

    setShowCards(false);
    invoiceList.reload();
  };

  const handleBackFromAddUpdate = () => {
    if (isEdit) {
      // From edit mode, return to full invoice preview (detail view), not list.
      setIsEdit(false);
      setForceAddMode(false);
      return;
    }

    // Add mode keeps previous behavior.
    if (showMobileDetailView) {
      handleBackToList();
      return;
    }
    setShowCards(true);
  };

  const handleInvoiceDelete = async (data: any) => {
    const invoiceId = String(data?.id ?? '').trim();
    if (!invoiceId) {
      ToastQueue.negative(
        t('missing_invoice_id', {
          ns: 'layout_components',
          defaultValue: 'Missing invoice id.',
        }),
        { timeout: 2500 },
      );
      return;
    }

    try {
      setShowLoaderDetail(true);
      const response: any = await invoiceService.deleteInvoice(
        new DeleteInvoiceRequest(
          store.Server,
          store.SessionId,
          invoiceId,
          data?.treeHandle ? String(data.treeHandle) : undefined
        )
      );

      if (response?.result === 'OK') {
        ToastQueue.positive(
          t('invoice_deleted_successfully', {
            ns: 'layout_components',
            defaultValue: 'Invoice deleted successfully.',
          }),
          { timeout: 2500 },
        );
        setSelectedItem(null);
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setShowCards(true);
        setShowMobileDetailView(false);
        setStopLoadData(false);
        totalProductListRec.current = 0;
        offSetLimit.current = 0;
        setRowsData([]);
        setShowLoader(true);
        setShowLoaderDetail(true);
        invoiceList.reload();
      } else {
        const errMsg =
          response?.EXCEPTION?.message ||
          response?.EXCEPTION?.reason ||
          t('failed_to_delete_invoice', {
            ns: 'layout_components',
            defaultValue: 'Failed to delete invoice.',
          });
        ToastQueue.negative(errMsg, { timeout: 3000 });
      }
    } catch (error: any) {
      ToastQueue.negative(
        error?.message ||
          t('failed_to_delete_invoice', {
            ns: 'layout_components',
            defaultValue: 'Failed to delete invoice.',
          }),
        { timeout: 3000 },
      );
    } finally {
      setShowLoaderDetail(false);
    }
  };

  useKeyboardShortcuts([...addKey('c', { ctrl: true, shift: true }, () => handleAddNew())], true);

  const shouldUseDesktopLayout = !deviceInfo.shouldUseMobileLayout() || ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape');

  const isTablet = deviceInfo.isTablet || deviceInfo.isIPad;

  const gridAreas = isTablet
    ? pageView === 'Full'
      ? (['header header', 'filter filter', 'card detail'] as any)
      : (['header header', 'filter filter', 'detail detail'] as any)
    : pageView === 'Full'
      ? (['filter header header', 'filter card detail'] as any)
      : (['filter header header', 'filter detail detail'] as any);

  // IMPORTANT: areas must match number of columns.
  // Tablet/iPad => 2 columns ALWAYS
  // Desktop     => 3 columns ALWAYS
  const gridColumns = isTablet
    ? {
      base: ['35%', '65%'],
      L: ['35%', '65%'],
    }
    : {
      base: ['245px', '28%', 'auto'],
      L: ['245px', '28%', 'auto'],
    };

  const gridRows = isTablet ? ['auto', 'auto', '1fr'] : ['auto', '1fr'];
  const isLocalAddMode = !showCards && forceAddMode && !isEdit;

  return (
    <>
      {!shouldUseDesktopLayout ?
        (
          <>
            {!showMobileDetailView && showCards && (
              <>
                <FilterComponent
                  onFilterChange={reloadInvoices}
                  filterParams={queryParams.current}
                  sumInvoice={sumInvoice}
                  invoiceStatusList={invoiceStatusList}
                  SELECTED_INVOICE={selectedInvoiceApiParams}
                />
                <View position={'relative'} width={'100%'} height={'100%'} UNSAFE_className={styles.card_list_parent}>
                  <Flex direction={'column'} position={'absolute'} width={'100%'} top={'72px'} left={'0%'} alignItems={'start'} justifyContent={'start'} gap={'12px'} maxHeight={'100vh'}>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <ListBox
                        id="invoiceCardsMobile"
                        selectionMode="single"
                        onSelectionChange={handleRowClickMobile}
                        onLoadMore={invoiceList.items.length > 40 ? invoiceList.loadMore : undefined}
                        marginStart={'18px'}
                        maxHeight={'100vh'}
                        minHeight={'130px'}
                        defaultSelectedKeys={selectedKeys}
                        aria-label={t('cards_mobile', { ns: 'invoice', defaultValue: 'Cards mobile' })}
                        items={invoiceList.items}
                        isLoading={invoiceList.isLoading}
                        width={'calc(100% - 32px)'}
                      >
                        {item => (
                          <Item key={item.id} textValue={item.name}>
                            <CardComponent item={item} invoiceType={invoiceType} />
                          </Item>
                        )}
                      </ListBox>
                    )}
                  </Flex>
                  <Flex
                    direction={'column'}
                    position={'absolute'}
                    width={'calc(100% - 32px)'}
                    top={'16px'}
                    right={'16px'}
                    left={'16px'}
                    alignItems={'start'}
                    justifyContent={'start'}
                    UNSAFE_className={styles.search_parent}
                  >
                    <Flex direction={'row'} alignSelf={'stretch'} height={'40px'} flexShrink={0} alignItems={'center'} justifyContent={'end'} gap={'8px'} UNSAFE_className={styles.search_field}>
                      <FilterSearchTextBox onSearchChange={reloadInvoices} filterParams={queryParams.current} serachedText={searchedValue} />
                      <i className={`${styles.icon_search} bi bi-search`}></i>
                    </Flex>
                  </Flex>
                  <Flex
                    direction={'row'}
                    position={'fixed'}
                    right={'16px'}
                    bottom={'95px'}
                    height={'48px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    gap={'8px'}
                    UNSAFE_className={styles.add_new_parent}
                  >
                    <Link onPress={handleAddNew} isQuiet aria-label={t('actions', { ns: 'invoice', defaultValue: 'Actions' })} UNSAFE_className={styles.add_new_btn}>
                      <i className="bi bi-plus fs-5">
                        <View UNSAFE_className={styles.add_new_btn_text}>{_tt('button_add_new')}</View>
                      </i>
                    </Link>
                  </Flex>
                </View>
              </>
            )}

            {(showMobileDetailView || !showCards) && (
              <>
                <Flex direction="column" alignItems={'start'} justifyContent={'center'} UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ padding: '0px', paddingTop: '0px' }}>
                  {selectedItem && (
                    <>
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <>
                          <View
                            UNSAFE_className={styles.service_status_bar}
                            marginBottom={'5px'}
                            marginTop={'0px'}
                            UNSAFE_style={{ backgroundColor: selectedItem.statusColor || '#000', width: '100%', height: '6px', borderRadius: '4px' }}
                          ></View>
                          {params.get('mode') === 'add' || isLocalAddMode || isEdit ? (
                            <AddUpdateInvoice
                              selectedInvoice={selectedItem}
                              isEdit={isEdit}
                              handleBackClick={handleBackFromAddUpdate}
                              onSaveSuccess={handleInvoiceSaveSuccess}
                              SELECTED_INVOICE={selectedInvoiceApiParams}
                            />
                          ) : (
                            <InvoiceDetailView
                              selectedInvoice={selectedItem}
                              invoiceStatusList={invoiceStatusList}
                              printType={getInvoicePrintType(selectedItem)}
                              onStatusChange={handleInvoiceStatusChange}
                              onRefreshInvoice={() => getLayout(String(selectedItem?.id || ''))}
                              onEdit={handleEditClick}
                              onDelete={() => setOpen(true)}
                              handleBackClick={handleBackToList}
                              SELECTED_INVOICE={selectedInvoiceApiParams}
                              isFullScreen
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                </Flex>
              </>
            )}
          </>
        ) :
        (showCards ? (
          <Grid
            areas={gridAreas}
            columns={gridColumns}
            rows={gridRows}
            height="100%"
            width="100%"
            // Avoid clipping header UI; if you MUST keep hidden, keep it but note dropdowns can clip.
            UNSAFE_style={{
              backgroundColor: '#f5f6f9',
              padding: '0px',
              margin: '0px',
              overflow: 'hidden auto',
            }}
          >
            {!(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View gridArea="filter">
                {showFilter ? (
                  <FilterComponent
                    onFilterChange={reloadInvoices}
                    filterParams={queryParams.current}
                    filterStyle={filterStyle}
                    sumInvoice={sumInvoice}
                    invoiceStatusList={invoiceStatusList}
                    SELECTED_INVOICE={selectedInvoiceApiParams}
                  />
                ) : (
                  <Flex
                    height={'100%'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    UNSAFE_style={{ backgroundColor: 'white' }}
                  >
                    <Loader />
                  </Flex>
                )}
              </View>
            )}

            {/* ✅ Header: removed height:'100%' which can collapse on auto rows in some mid widths */}
            <View width={'100%'} gridArea="header">
              <HeaderComponent
                onPageViewChange={handleViewChange}
                autoChanged={pageView}
                filterParams={queryParams.current}
                onSearchChange={reloadInvoices}
                fpaTypeCategory={serviceActivityValue.current}
                onAddNew={handleAddNew}
              />
            </View>

            {(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View
                gridArea="filter"
                UNSAFE_style={{
                  height: '60px',
                  backgroundColor: 'white',
                  borderBottom: '1px solid #e0e0e0',
                }}
              >
                <FilterComponent
                  onFilterChange={reloadInvoices}
                  filterParams={queryParams.current}
                  filterStyle={filterStyle}
                  sumInvoice={sumInvoice}
                  invoiceStatusList={invoiceStatusList}
                  SELECTED_INVOICE={selectedInvoiceApiParams}
                />
              </View>
            )}

            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View gridArea="card" UNSAFE_style={{ backgroundColor: '#f5f6f9', overflow: 'auto' }}>
                      {rowsData?.length > 0 ? (
                        <ListBox
                          autoFocus
                          id="invoiceCards"
                          selectionMode="single"
                          onSelectionChange={handleListRowClick}
                          onLoadMore={invoiceList.items.length > 45 ? invoiceList.loadMore : undefined}
                          marginStart={'15px'}
                          minHeight={'130px'}
                          defaultSelectedKeys={selectedKeys}
                          selectedKeys={selectedKeys}
                          aria-label={t('product_cards', { ns: 'invoice', defaultValue: 'Product cards' })}
                          items={invoiceList.items}
                          isLoading={invoiceList.isLoading}
                          UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                        >
                          {(item) => (
                            <Item key={item.id} textValue={item.name}>
                              <CardComponent item={item} invoiceType={invoiceType} />
                            </Item>
                          )}
                        </ListBox>
                      ) : (
                        <View marginTop={'13px'}>
                          <NoResultsMessage />
                        </View>
                      )}
                    </View>
                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      padding={'size-100'}
                      paddingTop={'0'}
                      marginTop={'17px'}
                      UNSAFE_style={detailStyle}
                      width={'100%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View height="100%" UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ overflow: 'hidden auto' }} marginStart={'10px'}>
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View
                                    UNSAFE_className={styles.service_status_bar}
                                    UNSAFE_style={{ backgroundColor: selectedItem.statusColor }}
                                  ></View>
                                  <View height={'2px'}>&nbsp;</View>
                                  <InvoiceDetailView
                                    selectedInvoice={selectedItem}
                                    invoiceStatusList={invoiceStatusList}
                                    printType={getInvoicePrintType(selectedItem)}
                                    onStatusChange={handleInvoiceStatusChange}
                                    onRefreshInvoice={() => getLayout(String(selectedItem?.id || ''))}
                                    onEdit={handleEditClick}
                                    onDelete={() => setOpen(true)}
                                    SELECTED_INVOICE={selectedInvoiceApiParams}
                                  />
                                </>
                              ) : (
                                <View marginTop={'13px'}>
                                  <NoResultsMessage />
                                </View>
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View
                    position={'relative'}
                    overflow={'auto'}
                    height={'100%'}
                    width={'100%'}
                    UNSAFE_className={styles.service_activities}
                  >
                    {rowsData?.length > 0 ? (
                      <InvoiceListTable
                        invoiceList={rowsData}
                        handleTableRowclick={handleTableRowClick}
                        handleEditClick={handleOpenInvoiceApp}
                        isInvoiceMainView={true}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        ) : (
          <Grid
            areas={pageView == 'Full' ? ['detail', 'detail'] : ['detail', 'detail']}
            columns={{ base: ['100%'], L: ['100%'] }}
            rows={['auto', '1fr']}
            width="100%"
            UNSAFE_style={{
              backgroundColor: '#f5f6f9',
              padding: '10px',
              margin: '0px',
              overflow: 'hidden',
              boxShadow: '1px 1px 24px 0 rgba(38, 50, 56, 0.04)',
            }}
          >
            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      UNSAFE_style={{ boxShadow: '1px 1px 24px 0 rgba(38, 50, 56, 0.04)' }}
                      width={'100%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ overflow: 'hidden auto' }} marginStart={'0px'}>
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View
                                    UNSAFE_className={styles.service_status_bar}
                                    UNSAFE_style={{ backgroundColor: selectedItem.statusColor }}
                                  ></View>
                                  <View height={'2px'}>&nbsp;</View>
                                  {params.get('mode') === 'add' || isLocalAddMode || isEdit ? (
                                    <AddUpdateInvoice
                                      selectedInvoice={selectedItem}
                                      isEdit={isEdit}
                                      handleBackClick={handleBackFromAddUpdate}
                                      onSaveSuccess={handleInvoiceSaveSuccess}
                                      SELECTED_INVOICE={selectedInvoiceApiParams}
                                    />
                                  ) : (
                                    <InvoiceDetailView
                                      selectedInvoice={selectedItem}
                                      invoiceStatusList={invoiceStatusList}
                                      printType={getInvoicePrintType(selectedItem)}
                                      onStatusChange={handleInvoiceStatusChange}
                                      onRefreshInvoice={() => getLayout(String(selectedItem?.id || ''))}
                                      onEdit={handleEditClick}
                                      onDelete={() => setOpen(true)}
                                      handleBackClick={() => setShowCards(true)}
                                      SELECTED_INVOICE={selectedInvoiceApiParams}
                                      isFullScreen
                                    />
                                  )}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View position={'relative'} overflow={'auto'} height={'100%'} width={'100%'} UNSAFE_className={styles.service_activities}>
                    {columnsData?.length > 0 && rowsData?.length > 0 ? (
                      <TableView
                        UNSAFE_className="tblLayoutComponent"
                        aria-label={t('products', { ns: 'invoice', defaultValue: 'Products' })}
                        selectionMode="single"
                        defaultSelectedKeys={selectedKeys}
                        selectionStyle="highlight"
                        width={{ base: '100%', L: '100%', M: '1100px' }}
                        minHeight={'100px'}
                        maxHeight={{ base: '100vh', L: '625px' }}
                        onAction={handleTableRowClick}
                      >
                        <TableHeader columns={columnsData}>
                          {(column: any) => (
                            <Column showDivider key={column.key} align={column.key === 'amount' ? 'end' : undefined}>
                              {column.name}
                            </Column>
                          )}
                        </TableHeader>
                        <TableBody
                          onLoadMore={invoiceList.items.length > 45 ? invoiceList.loadMore : undefined}
                          items={invoiceList.items}
                          loadingState={invoiceList.loadingState}
                        >
                          {(item: any) => (
                            <Row>
                              {columnKey => (
                                <Cell>
                                  {(() => {
                                    if (columnKey === 'amount') {
                                      return item[columnKey] && item[columnKey] > 0
                                        ? `${item[columnKey]} ${item['currencyName'] ? item['currencyName'] : ''}`
                                        : '0.00';
                                    } else {
                                      return item[columnKey];
                                    }
                                  })()}
                                </Cell>
                              )}
                            </Row>
                          )}
                        </TableBody>
                      </TableView>
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        )
        )
      }
      {/* <DialogContainer onDismiss={handleAddNewClose}>
        {showAdd && <AddUpdateInvoice
          invoice={selectedItem}
          isEdit={isEdit}
          onClose={handleAddNewClose}
          refreshDetailView={refreshDetailView}
          handleRefreshAddNewProduct={handleRefreshAddNewProduct}
          invoiceType={invoiceType} />
        }
      </DialogContainer> */}
      <DeleteConfirmationDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onConfirm={() => {
          handleInvoiceDelete(selectedItem);
          setOpen(false);
        }}
        itemName={selectedItem?.name}
      />
    </>
  );
}
